import React, { useEffect, useRef } from 'react';
import anime from 'animejs/lib/anime.es.js';
import { useTheme } from '../contexts/ThemeContext';

const GridBackground = () => {
  const gridRef = useRef(null);
  const { currentColors } = useTheme();

  useEffect(() => {
    // Animate grid background entrance
    anime({
      targets: gridRef.current,
      opacity: [0, 0.1],
      duration: 1500,
      delay: 3000,
      easing: 'easeOutQuart'
    });

    // Subtle floating animation for the grid
    anime({
      targets: gridRef.current,
      backgroundPositionX: ['0px', '47.6px'],
      backgroundPositionY: ['0px', '47.6px'],
      duration: 20000,
      loop: true,
      easing: 'linear'
    });
  }, []);

  return (
    <div 
      ref={gridRef}
      className="fixed inset-0 pointer-events-none z-0 transition-colors duration-500 opacity-0"
      style={{
        backgroundColor: currentColors.gridBg,
        backgroundImage: `
          linear-gradient(to right, ${currentColors.border} 1px, transparent 1px),
          linear-gradient(to bottom, ${currentColors.border} 1px, transparent 1px)
        `,
        backgroundSize: '47.6px 47.6px'
      }}
    />
  );
};

export default GridBackground;